import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, FormGroup, FormControl } from 'react-bootstrap'
import Phone, {
  isValidPhoneNumber,
  parsePhoneNumber
} from 'react-phone-number-input'
import styled from 'styled-components'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import messages from './messages'

const Wrapper = styled.div`
  p.footprint {
    padding: 20px !important;
  }
  .disclaim {
    color: var(--clr-grey-3-to-black);
    margin: 0;
  }
`
const SubmitButton = styled(Button)`
  height: var(--button-height);
  text-transform: uppercase;
  font-weight: 600;
`

const FootprintSurvey = ({ language, createFootprint }) => {
  const [footprintFName, setFootprintFName] = useState('')
  const [footprintLName, setFootprintLName] = useState('')
  const [footprintPhone, setFootprintPhone] = useState('')
  const [footprintEmail, setFootprintEmail] = useState('')

  const validatePhone = () => {
    return (
      footprintPhone === undefined ||
      footprintPhone.length === 0 ||
      isValidPhoneNumber(parsePhoneNumber(footprintPhone))
    )
  }

  const validateEmail = () => {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return footprintEmail.length === 0 || emailRegex.test(footprintEmail)
  }

  const handleSubmit = () => {
    createFootprint({
      footprintFName,
      footprintLName,
      footprintPhone,
      footprintEmail
    })
  }

  const translated = messages[language]

  return (
    <Wrapper>
      <p className="footprint">{translated.footprint1}</p>
      <p className="footprint">{translated.footprint2}</p>
      <form>
        <FormGroup role="form">
          <FormControl
            type="text"
            data-lpignore="true"
            placeholder="First name"
            value={footprintFName}
            name="footprintFName"
            onChange={e => setFootprintFName(e.target.value)}
          />
          <FormControl
            type="text"
            data-lpignore="true"
            placeholder="Last name"
            value={footprintLName}
            name="footprintLName"
            onChange={e => setFootprintLName(e.target.value)}
          />
          <Phone
            placeholder="Phone number"
            data-lpignore="true"
            className="form-control"
            id="phoneNumber"
            country="US"
            value={footprintPhone}
            onChange={phone => phone !== undefined && setFootprintPhone(phone)}
          />
          <FormControl
            type="text"
            data-lpignore="true"
            placeholder="Email"
            value={footprintEmail}
            name="footprintEmail"
            onChange={e => setFootprintEmail(e.target.value)}
          />
          <ul>
            {!validatePhone() && (
              <li className="error">{translated.phoneInvalid}</li>
            )}
            {!validateEmail() && (
              <li className="error">{translated.emailInvalid}</li>
            )}
          </ul>
          <SubmitButton
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={!validatePhone() || !validateEmail()}
          >
            Submit / Show Contact
          </SubmitButton>
        </FormGroup>
      </form>
      <small className="disclaim footprint">
        {translated.footprintDisclaim}
      </small>
    </Wrapper>
  )
}

FootprintSurvey.propTypes = {
  language: PropTypes.string,
  createFootprint: PropTypes.func.isRequired
}

export default LanguageProvider(FootprintSurvey)



// WEBPACK FOOTER //
// ./src/components/ContactUsModal/FootprintSurvey.js